import React, { Component } from 'react';
import { connect } from "react-redux";

import { emojiClicked } from '../../redux/actions';

import { TooltipSmiley } from '../atoms/tooltip/tooltip';
import Button from '../atoms/button/button';

class Emojis extends Component {
  render() {
    let emojiArray = [];
    let tooltip = ['terrible', 'bad', 'ok', 'good', 'amazing']
    for(let i = 1; i <= tooltip.length; i++ ) {
      const img = require(`../assets/emojis/emoji-${i}.png`);
      emojiArray.push(
        <TooltipSmiley position='bottom' key={i} content={tooltip[i-1]} onClick={() => this.props.emojiClicked(i)}>
          <img alt='Emoji' src={img} />
        </TooltipSmiley>
      )
    }
    return <div id='emojis'> {emojiArray} </div>
  }
}

export default connect(null, { emojiClicked })(Emojis);
